import PropTypes from 'prop-types';

const pricesPropTypes = PropTypes.shape({
  cents: PropTypes.number.isRequired,
  points: PropTypes.number.isRequired,
});

export { pricesPropTypes };
